/**
 * Cross-sell
 */
(function() {
  var $items = $('.Cart__ItemList [data-crosssell-collections]');
  var collections = {};
  var mainCollectionsInCart = [];
  var titles = ['Popular In', 'Top'];

  if ($items.length > 0) {
    $items.each(function() {
      var crosssell = $(this).data('crosssellCollections');
      var mainCollection = $(this).data('mainCollection');

      Object.keys(crosssell).forEach(function(itemKey) {
        if (collections[itemKey]) {
          collections[itemKey] += crosssell[itemKey];
        } else {
          collections[itemKey] = crosssell[itemKey];
        }
      });

      if (mainCollection) {
        mainCollectionsInCart.push(mainCollection);
      }
    });

    var sortedCollections = Object.entries(collections).sort(function(a, b) {
      return b[1] - a[1];
    });

    var newCollections = sortedCollections.filter(function(collection) {
      return !mainCollectionsInCart.includes(collection[0]);
    });

    var crosssellCollections = newCollections.slice(0, 2);

    crosssellCollections.forEach(function(crosssell, idx) {
      $.get('/collections/' + crosssell[0] + '?section_id=collection-crosssell')
        .then(function(html) {
          $('.cart-crosssell__list--' + idx).html(html);
          $('.cart-crosssell__list--' + idx + ' .SectionHeader__Heading').prepend(titles[idx] + ' ');
          $('.cart-crosssell__placeholder').hide();

          var productList = document.querySelector('.cart-crosssell__list--' + idx + ' .ProductList');
          new window.ProductItemColorSwatch(productList);

          $(productList).find('.ProductItem').each(function() {
            var $item = $(this);
            var selectedColor = $item.find('.ColorSwatch__Radio:checked').data('color-handle');
            handleColorSwitchImages($item, selectedColor);
          });
        });
    });
  }

/**
 * Product Item Colors
 */
 $('.cart-crosssell').on('click', '.js-show-all-colors', function(e) {
    e.preventDefault();
    $(this).siblings('.ProductItem__ColorSwatchItem').show();
    $(this).remove();
  });
})();

$('.template-cart .Cart__Footer .Cart__Usp .Cart__UspItem h3').on('click', function() {
  $(this).toggleClass('open');
});

$('.template-product .Product__Usp .Product__UspItem h3').on('click', function() {
  $(this).toggleClass('open');
});

$('[data-cart-add-gift-msg]').on('click', function(e) {
  e.preventDefault();
  $(this).hide();
  $('.Cart__GiftMessage').toggleClass('open');
});